// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Déposez vos fichiers ici : PDF, photos, Excel, CSV ou Word',
  waiting: "L'envoi attend la fin du téléversement des fichiers.",
  // A message sent while New chat is starting waits for the new chat (QA90).
  starting: 'Un instant : le nouveau chat démarre et votre message y sera envoyé.',
  // A message that waits for the person to deal with a file that can't go with it (QA121).
  blocked: {
    refused: 'Retirez le fichier qui ne peut pas être envoyé, puis envoyez votre message.',
    failed: "Relancez l'envoi du fichier ou retirez-le, puis envoyez votre message.",
  },
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} page',
  pages_other: '{{count}} pages',
  problems: {
    type: 'Ce type de fichier ne peut pas être envoyé. Envoyez un PDF, une photo (JPG, PNG ou HEIC) ou un fichier Excel, CSV ou Word.',
    size: "Plus de 20 Mo. Un fichier peut peser jusqu'à 20 Mo.",
    empty: 'Ce fichier est vide.',
    count: "Jusqu'à 10 fichiers par message.",
    upload: "Le téléversement s'est interrompu. Réessayez.",
  },
};
